import React from 'react';
import ReactDOM from 'react-dom/client';
import { GDLV2, DataLayerProvider } from 'react-common-gdlv2';
import { BrowserRouter as Router } from "react-router-dom";
import { getBrandCodeDomain, getEnv } from './utils/utils';
import THEMES from './constants/theme-properties';
import './index.css'
import App from './App'
import { PAGE_DATA } from './dataLayer/config/routing/pageData'

//Initialize data layer and provide data layer configuration
const gdlv2 = GDLV2({
    server: "Debit Card - Browser Autofill Storage",
    brands: {
      'rbs.co.uk': 'RBS',
      'natwest.com': 'NatWest',
      'ulsterbank.co.uk': 'Ulster NI',
      'natwestinternational.com': 'NatWest International',
      'localhost': 'NatWest'
    },
    queryParamsBlacklist: ['token', 'cc-name', 'cc-number', 'cc-exp-month', 'cc-exp-year'],
    pageData: PAGE_DATA
  });

  if(getEnv())
    gdlv2.setDebug(true);
  else
    gdlv2.setDebug(false);

const brand = getBrandCodeDomain();
const theme = THEMES[brand].name;

import(`@zambezi/sdk-themes/${theme}/theme.min.css`);
import(`@zambezi/sdk-themes/${theme}/icons`);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <DataLayerProvider instance={gdlv2}>
      <App />
    </DataLayerProvider>
  </Router >
);
